import { JobImportPage } from "@/features/job/pages/JobImport";

const JobImport = () => {
  return <JobImportPage />;
};

export default JobImport;
